import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Eye, EyeOff, Mail, Lock } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LoginFormProps {
    formData: {
        email: string;
        password?: string;
    };
    isLoading: boolean;
    showPassword: boolean;
    setShowPassword: (show: boolean) => void;
    handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onForgotPassword: () => void;
    isDrawer?: boolean;
}

export const LoginForm: React.FC<LoginFormProps> = ({
    formData,
    isLoading,
    showPassword,
    setShowPassword,
    handleInputChange,
    onForgotPassword,
    isDrawer
}) => {
    return (
        <div className={cn("space-y-4", isDrawer ? "px-4" : "")} dir="rtl">
            {/* Email Field */}
            <div className="space-y-2">
                <Label htmlFor="email" className="text-right block">אימייל</Label>
                <div className="relative">
                    <Mail className="absolute right-3 top-3 h-4 w-4 text-muted-foreground" />
                    <Input
                        id="email"
                        name="email"
                        type="email"
                        placeholder="your@email.com"
                        className="pr-9"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        autoComplete="email"
                    />
                </div>
            </div>

            {/* Password Field */}
            <div className="space-y-2">
                <div className="flex items-center justify-between">
                    <Label htmlFor="password">סיסמה</Label>
                    <Button
                        type="button"
                        variant="link"
                        className="px-0 font-normal text-xs text-muted-foreground"
                        onClick={onForgotPassword}
                    >
                        שכחתי סיסמה
                    </Button>
                </div>
                <div className="relative">
                    <Lock className="absolute right-3 top-3 h-4 w-4 text-muted-foreground" />
                    <Input
                        id="password"
                        name="password"
                        type={showPassword ? "text" : "password"}
                        placeholder="******"
                        className="pr-9 pl-9"
                        value={formData.password || ''}
                        onChange={handleInputChange}
                        required
                        autoComplete="current-password"
                    />
                    <Button
                        type="button"
                        variant="ghost"
                        size="icon"
                        className="absolute left-0 top-0 h-full px-3 hover:bg-transparent"
                        onClick={() => setShowPassword(!showPassword)}
                    >
                        {showPassword ? (
                            <EyeOff className="h-4 w-4 text-muted-foreground" />
                        ) : (
                            <Eye className="h-4 w-4 text-muted-foreground" />
                        )}
                        <span className="sr-only">
                            {showPassword ? 'הסתר סיסמה' : 'הצג סיסמה'}
                        </span>
                    </Button>
                </div>
            </div>

            {/* Submit Button (Implicitly handled by form wrapper in parent usually, 
          but usually we put the button inside the form content. 
          If parent wraps in <form>, this is just fields. 
          But wait, typically submitting is done by a button with type="submit".
          AuthModal puts the button in the Footer for Dialogs usually? 
          Let's check AuthModal structure.) 
      */}
        </div>
    );
};
